import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Arcade from "@/pages/Arcade";
import Charts from "@/pages/Charts";
import History from "@/pages/History";
import AuthCallback from "@/pages/AuthCallback";
import AiAssistant from "@/components/AiAssistant";
import { resolveDerivAppId } from "@/lib/api";
import { InstallPrompt } from "@/components/casino/InstallPrompt";

function App() {
  // Resolve the real Deriv app_id from /api/config as early as possible so every
  // Connect button has the right OAuth URL by the time the user clicks it.
  useEffect(() => { resolveDerivAppId().catch(() => {}); }, []);
  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref && /^[a-z0-9]{4,16}$/i.test(ref)) localStorage.setItem("naevo_ref", ref.toLowerCase());
    if ("serviceWorker" in navigator) navigator.serviceWorker.register("/sw.js").catch(() => {});
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/arcade" element={<Arcade />} />
          <Route path="/charts" element={<Charts />} />
          <Route path="/history" element={<History />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <AiAssistant />
        <InstallPrompt />
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}

export default App;
